import React, { Children } from 'react';
import { motion } from 'framer-motion';
// Concepto 2: Señal con reveal secuencial
// Las tres frases aparecen en cadena con 1.2s de pausa entre ellas.
// El efecto es de conversación, no de animación.
const phraseVariants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: 'easeOut'
    }
  }
};
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 1.2
    }
  }
};
export function SignalSection() {
  return <section className="bg-gradient-section px-5 md:px-8" style={{
    padding: '7rem 0'
  }} data-id="element-297" data-mp="3dsbfgjmd7qkl">
      <div className="max-w-2xl mx-auto" data-id="element-298" data-mp="2zyk6bccjq8pe">
        {/* Eyebrow — pequeño, sutil */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="uppercase tracking-[0.28em] text-[#C8A870] font-semibold mb-14 text-[11px] text-center" style={{
        fontFamily: 'sans-serif'
      }} data-id="element-299" data-mp="34wc6sur9b357">
          Lo que está pasando
        </motion.p>

        {/* Bloque de frases secuenciales */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.4
      }} className="text-left md:text-center" data-id="element-300" data-mp="1996x0lmc7yma">
          {/* Frase 1 — la más grande */}
          <motion.h2 variants={phraseVariants} className="font-display font-semibold text-[#F0E8D8] leading-[1.08] tracking-tight" style={{
          fontSize: 'clamp(34px, 7vw, 54px)',
          marginBottom: '0.2em'
        }} data-id="element-301" data-mp="1x02thw1qnhzv">
            Tu cuerpo
            <br data-id="element-302" data-mp="25z6fp8w7cdil" />
            no falló.
          </motion.h2>

          {/* Espacio visual entre frases */}
          <div style={{
          height: '1.6em'
        }} data-id="element-303" data-mp="2103cltzs8hd9" />

          {/* Frase 2 — gold italic */}
          <motion.p variants={phraseVariants} className="font-display italic text-gradient-gold leading-[1.1]" style={{
          fontSize: 'clamp(30px, 6vw, 48px)',
          marginBottom: '0.2em'
        }} data-id="element-304" data-mp="bp2qmj1cb5pq">
            Cambió la señal.
          </motion.p>

          {/* Espacio visual */}
          <div style={{
          height: '1.6em'
        }} data-id="element-305" data-mp="2brlkrdmn2l6g" />

          {/* Frase 3 — pequeña, apagada */}
          <motion.p variants={phraseVariants} className="font-display text-[#F0E8D8]/55" style={{
          fontSize: 'clamp(18px, 3.5vw, 26px)'
        }} data-id="element-306" data-mp="2gqycocsdaifw">
            Y nadie te enseñó a leerla.
          </motion.p>
        </motion.div>

        {/* Párrafo explicativo — aparece después */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} className="mt-16 font-body text-[#F0E8D8]/60 max-w-lg text-center mx-auto" style={{
        fontSize: 'clamp(15px, 2.5vw, 18px)',
        lineHeight: 1.7
      }} data-id="element-307" data-mp="2um0hsxpe43rn">
          los cambios hormonales hacen que lo que antes funcionaba ya no
          alcance. H·E·R fue diseñado para acompañar esta etapa de forma simple
          y sostenible.
        </motion.p>

        <div className="divider-fine w-16 mx-auto mt-16" data-id="element-308" data-mp="wuiueatr8p0p" />
      </div>
    </section>;
}